module.exports = __webpack_public_path__ + "images/content/create_and_share_documents.gif";